import { render, staticRenderFns } from "./ssLoginError.vue?vue&type=template&id=71c31515&scoped=true"
import script from "./ssLoginError.vue?vue&type=script&lang=js"
export * from "./ssLoginError.vue?vue&type=script&lang=js"
import style0 from "./ssLoginError.vue?vue&type=style&index=0&id=71c31515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c31515",
  null
  
)

export default component.exports